import * as BaggageServiceStyles from './components/BaggageService.css';
import * as AdditionalStyles from './components/Additional/Additional.css';
export default {
    BaggageServiceStyles,
    AdditionalStyles
};
